import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-carousel-light-demo',
  templateUrl: './carousel-light-demo.component.html',
})
export class NgbCarouselLightDemoComponent {}
